import { Controller } from 'react-hook-form';

import { AdvancedControls } from '@/components/base/advanced-controls';
import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

export function TalrooForm() {
  const { hookForm, campaign, isCompleted } = useEditCampaignContext();

  return (
    <>
      <Dates />
      <Budget />
      <Controller
        control={hookForm.control}
        name="is_location_sensitive"
        render={({ field }) => (
          <AdvancedControls
            isLocationSensitive={!!field.value}
            onLocationSensitiveChange={field.onChange}
            screenableOpeningCount={campaign?.is_remote ? 0 : 1}
            openingCount={1}
            isReadOnly={isCompleted || !!campaign?.is_readonly}
          />
        )}
      />
      <TargetBudget />
    </>
  );
}
